<template>
  <v-layout v-if="confirmer.active" row justify-center>
    <v-dialog :value="confirmer.active" persistent max-width="290">
      <v-card data-test="destroy-dialog">
        <v-card-title class="headline">{{confirmer.title}}</v-card-title>
        <v-card-text v-if="confirmer.body">{{confirmer.body}}</v-card-text>
        <v-card-actions>
          <v-btn color="gray darken-1" text @click.native="cancel" data-test="cancel">{{ $t('cancel')}}</v-btn>
          <v-spacer/>
          <v-btn color="blue darken-1" text @click.native="confirm" data-test="confirm">{{ $t('confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  computed: {
    confirmer () {
      return this.$store.state.destroyDialog
    }
  },
  methods: {
    confirm () {
      console.log(this.confirmer)
      this.confirmer.resolve(true)
      this.$store.commit('hideDestroyDialog')
    },
    cancel () {
      this.confirmer.resolve(false)
      this.$store.commit('hideDestroyDialog')
    }
  }
}
</script>
